import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import EventVisitDetailsAgenda from '../../containers/RepVisitsCalendarEventDetailsAgenda/event-visit';
import EventFairDetailsAgenda from '../../containers/RepVisitsCalendarEventDetailsAgenda/event-fair';

const EventAgenda = ({ event }) => {
  if (event.dayId) {
    return (
      <EventVisitDetailsAgenda
        appointmentId={event.appointmentId}
        id={get(event, 'highSchool.id')}
      />
    );
  } else {
    return (
      <EventFairDetailsAgenda
        id={event.collegeFairId}
      />
    );
  }
};

EventAgenda.propTypes = {
  event: PropTypes.object,
};

export default injectIntl(EventAgenda);
